import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Table, Column } from 'react-virtualized';
import { onSnapshot } from 'mobx-state-tree';
import 'react-virtualized/styles.css';

class VirtualizedTable extends Component {

  constructor(props) {
    super(props)
    this.gridRef = React.createRef()
  }

  componentDidMount() {
    onSnapshot(this.props.store, snapshot => {
      if (this.gridRef.current) {
        this.gridRef.current.forceUpdateGrid()
      }
    })
  }

  render() {
    const { columns, items, onClickItem, rowClassFunction } = this.props
    const getColumns = width => columns.filter(c => !(c.hideBelowWidth > width))
    return (
      <Table
        ref={this.gridRef}
        width={this.props.width}
        height={this.props.height}
        headerHeight={42}
        rowHeight={42}
        rowCount={items.length}
        rowGetter={({ index }) => items[index]}
        onRowClick={onClickItem}
        rowClassName={rowClassFunction || null}
      >
        {getColumns(this.props.width).map(c => (
          <Column
            key={c.key}
            label={c.label}
            dataKey={c.key}
            width={c.width}
            className={c.className || null}
          />
        ))}
      </Table>
    )
  }
}

export default inject('store')(observer(VirtualizedTable));


// WEBPACK FOOTER //
// ./src/components/common/VirtualizedTable.js